import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Permission } from '@/composables/policies/permissions'

export const usePermissionsStore = defineStore('permissions', () => {
  // Raw strings from the API — setPermissions accepts whatever the backend
  // sends. can/canAny/canAll are typed against Permission so call sites get
  // typo-proof checks against the PERMISSIONS registry.
  const permissions = ref<string[]>([])

  function can(permission: Permission): boolean {
    return permissions.value.includes(permission)
  }

  function canAny(perms: Permission[]): boolean {
    return perms.some(p => permissions.value.includes(p))
  }

  function canAll(perms: Permission[]): boolean {
    return perms.every(p => permissions.value.includes(p))
  }

  function setPermissions(perms: string[]): void {
    permissions.value = perms
  }

  return { permissions, can, canAny, canAll, setPermissions }
})
